import {
  EnumVerificaResponseTipoVerificaEnum,
  VerificaResponse,
} from '@framework/api-client';
import { t } from '@framework/i18n';

/**
 * Estrae lo stato e il messaggio di una verifica
 */
export function getVerificationResultInfo(
  verificationResponse?: VerificaResponse,
) {
  switch (verificationResponse?.tipoVerificaEnum) {
    case EnumVerificaResponseTipoVerificaEnum.OK:
      return {
        status: 'success',
        message:
          verificationResponse?.messaggio ??
          t(
            'verification-result-info.verifica-completata-con-successo',
            'Verifica completata con successo',
          ),
      };
    case EnumVerificaResponseTipoVerificaEnum.WARNING:
      return {
        status: 'warning',
        message:
          verificationResponse?.messaggio ??
          t(
            'verification-result-info.verifica-completata-con-warning',
            'Verifica completata con warning',
          ),
      };
    case EnumVerificaResponseTipoVerificaEnum.ERRORE:
    default:
      return {
        status: 'error',
        message:
          verificationResponse?.messaggio ??
          t(
            'verification-result-info.errore-in-verifica',
            'Errore in verifica',
          ),
      };
  }
}
